// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_propertyType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "CondoProperty",
    "SingleFamilyProperty"
  ]);
}

let fragmentConverter = {"__root":{"propertyType_SingleFamilyProperty":{"f":""},"propertyType_CondoProperty":{"f":""},"propertyType":{"u":"fragment_propertyType"}}};

let fragmentConverterMap = {
  fragment_propertyType: unwrap_fragment_propertyType
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RentalPropertyAttributes_property",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "propertyType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CondoPropertyAttributes_condoProperty"
              }
            ],
            "type": "CondoProperty",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SingleFamilyPropertyAttributes_singleFamilyProperty"
              }
            ],
            "type": "SingleFamilyProperty",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "RentalPropertyV5",
  "abstractKey": null
};

let wrap_fragment_propertyType = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_propertyType = unwrap_fragment_propertyType;
exports.wrap_fragment_propertyType = wrap_fragment_propertyType;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
